import { createStore } from 'vuex'
import axios from 'axios'

export default createStore({
  state: {
    collections: [],
    accueil: null,
    contact: null,
    horaires: null,
    propos:null,
    vignettes: [],
    isLoading: false,
    error: null
  },
  getters: {
    getCollections: (state) => state.collections,
    getAccueil: (state) => state.accueil,
    getPropos: (state) => state.propos,
    getContact: (state) => state.contact,
    getHoraires: (state) => state.horaires,
    getVignettes: (state) => state.vignettes,
    isLoading: (state) => state.isLoading,
    getError: (state) => state.error
  },
  mutations: {
    SET_COLLECTIONS(state, collections) {
      state.collections = collections
    },
    SET_ACCUEIL(state, accueil) {
      state.accueil = accueil
    },
    SET_PROPOS(state, propos) {
      state.propos = propos
    },
    SET_CONTACT(state, contact) {
      state.contact = contact
    },
    SET_HORAIRES(state, horaires) {
      state.horaires = horaires
    },
    SET_VIGNETTES(state, vignettes) {
      state.vignettes = vignettes
    },
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    async fetchCollections({ commit }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const response = await axios.get('https://admin.mia-restaurant.fr/collections')
        commit('SET_COLLECTIONS', response.data)
        return response.data
      } catch (error) {
        commit('SET_ERROR', error.message)
        console.error('Error fetching collections:', error)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async fetchAccueil({ commit }) {
      try {
        const response = await axios.get('https://admin.mia-restaurant.fr/contenu/accueil')
        commit('SET_ACCUEIL', response.data)
        return response.data
      } catch (error) {
        commit('SET_ERROR', error.message)
        console.error('Error fetching accueil content:', error)
        throw error
      }
    },

    async fetchContact({ commit }) {
      try {
        const response = await axios.get('https://admin.mia-restaurant.fr/contenu/contact')
        commit('SET_CONTACT', response.data)
        return response.data
      } catch (error) {
        commit('SET_ERROR', error.message)
        console.error('Error fetching contact content:', error)
        throw error
      }
    },

    async fetchHoraires({ commit }) {
      try {
        const response = await axios.get('https://admin.mia-restaurant.fr/contenu/horaires')
        commit('SET_HORAIRES', response.data)
        return response.data
      } catch (error) {
        commit('SET_ERROR', error.message)
        console.error('Error fetching horaires:', error)
        throw error
      }
    },

    async fetchVignettes({ commit }) {
      try {
        const response = await axios.get('https://admin.mia-restaurant.fr/contenu/vignettes')
        commit('SET_VIGNETTES', response.data)
        return response.data
      } catch (error) {
        commit('SET_ERROR', error.message)
        console.error('Error fetching vignettes:', error)
        throw error
      }
    },
    async fetchPropos({ commit }) {
      try {
        const response = await axios.get('https://admin.mia-restaurant.fr/contenu/A_propos')
        commit('SET_PROPOS', response.data)
        return response.data
      } catch (error) {
        commit('SET_ERROR', error.message)
        console.error('Error fetching vignettes:', error)
        throw error
      }
    },

    async fetchAllData({ dispatch, commit }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        await Promise.all([
          dispatch('fetchCollections'),
          dispatch('fetchAccueil'),
          dispatch('fetchContact'),
          dispatch('fetchHoraires'),
          dispatch('fetchVignettes'),
          dispatch('fetchPropos')
        ]);
      } catch (error) {
        commit('SET_ERROR', error.message)
        console.error('Error fetching all data:', error)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  modules: {
  }
})
